<template>
  <div>
    <spinner v-if="loading"></spinner>

    <div v-else>
      <div>
        <h1 class="text-2xl font-bold text-center text-primary">
          ผลการประเมินด้านพฤติกรรมสร้างเสริมสุขภาพ
        </h1>
        <h1 class="text-xl font-light text-center">
          Health Promotion Lifestyle Profile: Healthy CMU’Version (HPLP)
        </h1>
      </div>

      <div class="">
        <p>แบ่งตามหน่วยงาน</p>
        <a-select
          @change="fetchFacultySummary"
          v-model="selectedFaculty"
          show-search
          placeholder="Select a person"
          option-filter-prop="children"
          style="width: 350px"
          class="mt-2"
        >
          <a-select-option
            v-for="faculty in faculties"
            :key="faculty"
            :value="faculty"
          >
            {{ faculty }}
          </a-select-option>
        </a-select>
      </div>

      <div class="card">
        <h1 class="text-lg font-bold text-center">
          แสดงการเปลี่ยนแปลงผลการประเมินในแต่ละเดือน
        </h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ facultySummary.numberOfPeople }} คน
        </p>
        <average-sd-stacked-bar-chart
          :labels="facultySummary.monthlySummary.months"
          :averages="facultySummary.monthlySummary.averages"
          :enableAverageLine="false"
          :enableSdLine="false"
          :yMax="35"
        ></average-sd-stacked-bar-chart>
      </div>

      <div class="card">
        <h1 class="text-lg font-bold text-center">แบ่งตามประเภทพนักงาน</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ facultySummary.numberOfPeople }} คน
        </p>
        <hplp-stacked-bar-chart
          class="bar-chart"
          :labels="facultySummary.groups.employeeType.groups"
          :low="
            facultySummary.groups.employeeType.finalResults.low.numbersOfPeople
          "
          :fair="
            facultySummary.groups.employeeType.finalResults.fair.numbersOfPeople
          "
          :good="
            facultySummary.groups.employeeType.finalResults.good.numbersOfPeople
          "
          :veryGood="
            facultySummary.groups.employeeType.finalResults.good.numbersOfPeople
          "
        >
        </hplp-stacked-bar-chart>
      </div>

      <div class="mt-12 card">
        <h1 class="text-lg font-bold text-center">แบ่งตามเพศ</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ facultySummary.numberOfPeople }} คน
        </p>
        <hplp-stacked-bar-chart
          class="bar-chart"
          :labels="facultySummary.groups.gender.groups"
          :low="facultySummary.groups.gender.finalResults.low.numbersOfPeople"
          :fair="facultySummary.groups.gender.finalResults.fair.numbersOfPeople"
          :good="facultySummary.groups.gender.finalResults.good.numbersOfPeople"
          :veryGood="
            facultySummary.groups.gender.finalResults.good.numbersOfPeople
          "
        >
        </hplp-stacked-bar-chart>
      </div>
    </div>
  </div>
</template>

<script>
import HPLPStackedBarChart from "@/components/charts/HPLPStackedBarChart";
import AverageSdStackedBarChart from "@/components/charts/AverageSdStackedBarChart";

import axios from "axios";
import { faculties } from "@/data/group.js";
import Spinner from "@/components/loading/Spinner";
import EventBus from "@/events/event-bus.js";

export default {
  components: {
    "hplp-stacked-bar-chart": HPLPStackedBarChart,
    AverageSdStackedBarChart,
    Spinner,
  },
  created() {
    this.fetchFacultySummary();

    EventBus.$on("dashboardYearChanged", this.fetchFacultySummary);
    EventBus.$on("dashboardEmployeeTypeChanged", this.fetchFacultySummary);
  },
  beforeDestroy() {
    EventBus.$off("dashboardYearChanged", this.fetchFacultySummary);
    EventBus.$off("dashboardEmployeeTypeChanged", this.fetchFacultySummary);
  },
  data() {
    return {
      faculties,
      facultySummary: {},
      selectedFaculty: "มหาวิทยาลัยเชียงใหม่",
      loading: false,
    };
  },
  methods: {
    async fetchFacultySummary() {
      this.loading = true;

      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/dashboard/hplp/faculty?faculty=${this.selectedFaculty}&year=${this.$store.state.dashboardYear}&employeeType=${this.$store.state.dashboardEmployeeType}`,
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.facultySummary = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
